import { MutationTree } from 'vuex';
import { DiscoveryWallState } from '../../models';
import { ResetDiscoveryWallStateMutation } from './mutations/reset-discovery-wall-state.mutation';
import { SetDiscoveryWallLoadingMutation } from './mutations/set-discovery-wall-loading.mutation';
import { SetDiscoveryWallStateMutation } from './mutations/set-discovery-wall-state.mutation';

export const DISCOVERY_WALL_MUTATIONS: MutationTree<DiscoveryWallState> = {
 ...new ResetDiscoveryWallStateMutation().mutations,
 ...new SetDiscoveryWallStateMutation().mutations,
 ...new SetDiscoveryWallLoadingMutation().mutations
};
